import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import autoShowModal from '../modifiers/auto-show-modal.js';

<template>
  <dialog
    class="modal"
    {{autoShowModal}}
    {{on "cancel" @onClose}}
    {{on "close" @onClose}}
  >
    <form aria-label="modal" method="dialog" class="modal-box p-0" ...attributes>
      {{yield}}
    </form>
    <form aria-label="backdrop" method="dialog" class="modal-backdrop">
      <button type="submit">{{t "close"}}</button>
    </form>
  </dialog>
</template>
